module.exports = __webpack_public_path__ + "static/media/GitHub-Mark-Light-64px.ae8aff4c.png";